import {openModal} from '../Actions'
import SubscribeModal from './';

export const openSubscribeModal = () => openModal(SubscribeModal);
